import { useNotifications } from "@/shared/notification";

const CHECK_INTERVAL_MS = 60 * 1000; // check every 60 seconds
const VERSION_URL = "/version.json";
const NOTIFICATIONS_GROUP = "app-update";

let currentVersion: string | null = null;
let started = false;
let notificationShown = false;

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch(`${VERSION_URL}?_=${Date.now()}`, {
      cache: "no-store",
      headers: { "Cache-Control": "no-cache" },
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { version: string };
    return data.version ?? null;
  } catch {
    return null;
  }
}

async function checkForUpdate() {
  const latest = await fetchVersion();
  if (!latest) return;

  if (currentVersion === null) {
    // First check — record the current version
    currentVersion = latest;
    return;
  }

  if (latest !== currentVersion && !notificationShown) {
    notificationShown = true;
    showUpdateNotification();
  }
}

function showUpdateNotification() {
  const notifications = useNotifications();

  notifications.info({
    duration: 0, // persistent until user acts
    group: NOTIFICATIONS_GROUP,
    singleInGroup: true,
    text: "نسخه جدید موجود است!",
    button: {
      text: "به‌روزرسانی",
      clickHandler() {
        notifications.clear(NOTIFICATIONS_GROUP);
        window.location.reload();
      },
    },
  });
}

/**
 * Start polling for new app versions.
 * Uses a lightweight version.json polling mechanism.
 * Should be called once from the root component.
 */
export function useAppUpdate() {
  if (!started) {
    started = true;
    // Initial check
    void checkForUpdate();
    // Periodic checks
    setInterval(() => {
      void checkForUpdate();
    }, CHECK_INTERVAL_MS);
  }
}
